import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style';

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1 1 auto;
  background-color: ${({ bgColor }) => bgColor || 'inherit'};

  @media(max-width: ${device.laptop}) {
    flex-direction: column;
    width: auto;
  }
`;

export default ({ className, ...rest }) => <FeaturesContainer className={className} {...rest} />;
